import type { RouteObject } from 'react-router-dom';

import { PublicLayout } from 'src/layouts';
import { LoginScreen } from 'src/screens/publicScreens';

const _publicRoutes: RouteObject[] = [
  {
    element: <PublicLayout />,
    children: [
      {
        element: <LoginScreen />,
        path: 'login'
      }
    ]
  }
];

export default _publicRoutes;
